export const SourceTypeEnum = {
    SLCQuestionnaire: 1,
    StorylineQuestionnaire: 2,
    IDE: 3
}
export const SourceTypeTextEnum = {
    SLCQuestionnaire: "SLCQuestionnaire",
    StorylineQuestionnaire: "StorylineQuestionnaire",
    IDE: "IDE"
}